module.exports = __webpack_public_path__ + "bb.svg?15cb2720963727bf159655d4236736fa";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bb.svg
// module id = 1193
// module chunks = 27